<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <h5>検索条件</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">申請種別</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <bs-select
                :options="application_type_list"
                v-model="sprm.application_type"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">完了区分</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <bs-select
                :options="application_check_type_list"
                v-model="sprm.application_check_type"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">クラブコード</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="sprm.club_no"
                class="form-control"
                @change="search_club_no()"
                :disabled="sprm.like_name || sprm.like_yomi ? true : false"
              />
              <button
                @click="search_club_no()"
                :disabled="sprm.like_name || sprm.like_yomi ? true : false"
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                クラブコードから検索
              </button>
            </div>
          </div>
          <div class="col-3 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_club_obj.name_label"
              class="form-control"
              placeholder="クラブ名"
              disabled="true"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">クラブ名/カナ</p>
          </div>
          <div class="col-5 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="sprm.like_name"
              class="form-control"
              placeholder="クラブ名"
              :disabled="sprm.club_no ? true : false"
            />
          </div>
          <div class="col-5 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="sprm.like_yomi"
              class="form-control"
              placeholder="クラブ名(カナ)"
              :disabled="sprm.club_no ? true : false"
            />
          </div>
        </div>
        <div class="row mb-2 d-none">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">申請日</p>
          </div>
          <div class="col-8 mb-2">
            <div class="input-group">
              <input
                type="date"
                v-model="sprm.application_date_higher"
                class="form-control"
                placeholder=""
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                v-model="sprm.application_date_lower"
                class="form-control"
                placeholder="会員名"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2 mb-2"></div>
          <div class="col-2 mb-2"></div>
          <div class="col-4 mb-2"></div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">表示件数</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="get_page_num_list"
              v-model="page_limit"
              :null-option="false"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_application"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="
        typeof application_list === 'object' &&
        Object.keys(application_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th>申請No</th>
            <th>申請日時</th>
            <th>完了区分</th>
            <th>申請種別</th>
            <th>クラブコード</th>
            <th>クラブ名</th>
            <th>クラブヨミ</th>
            <th>状態</th>
            <!-- <th>経過時間</th>
            <th>前回処理</th>
            <th>今回処理</th> -->
            <th>対応指示</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in application_list" :key="list.id">
            <td>{{ list.id }}</td>
            <td>{{ list.application_date }}</td>
            <td>
              {{
                get_label_list(
                  getDisplayStatus(list.application_check_type),
                  application_check_type_display
                )
              }}
            </td>
            <td>
              {{ get_label_list(list.application_type, application_type_list) }}
            </td>
            <td>{{ list.club_no }}</td>
            <td>{{ list.name_label }}</td>
            <td>{{ list.d_name_label }}</td>
            <td>
              {{
                get_label_list(
                  list.application_check_type,
                  application_check_type_list
                )
              }}
            </td>
            <!-- <td>{{ list.diff_time }}</td>
            <td>{{ list.before_edit_manage_label }}</td>
            <td>{{ list.edit_manage_label }}</td> -->
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
    <bs-page-nav
      :pager_key="'club_application_list'"
      @to_click_event="pageAction"
    ></bs-page-nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'

export default {
  name: 'ApplicationListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '申請データ一覧',
      fromParentBtn: 'データ登録',
      sprm: {
        stat: [1],
        club_no: '',
        like_name: '',
        like_yomi: '',
        application_date: '',
        application_date_higher: '',
        application_date_lower: '',
        search_words: '',
        affiliation: '',
        application_check_type: '',
        application_type: ''
      },
      page: 0,
      page_limit: 10,
      application_obj: [],
      application_type_obj: [],
      application_check_type_obj: [],
      search_club_obj: {},
      statusMap: {
        0: '0', // 未登録
        100: '100', // 申請中
        120: '100', // 再申請
        200: '100', // 確認中
        300: '100', // 処理中
        500: '500', // 完了
        900: '900' // 取消
      },
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    ...mapState({}),
    get_label_list: function () {
      return function (code, lists) {
        if (typeof lists === 'object' && lists.find(list => list.key == code)) {
          return (lists.find(list => list.key == code) || {}).label
        }
        return code
      }
    },
    application_type_list: function () {
      return this.application_type_obj.filter(
        app_type => parseInt(app_type.key) >= 20000
      )
    },
    application_check_type_list: function () {
      return this.application_check_type_obj.filter(chk_type => {
        if (
          [300, 340, 360, 400, 403, 420, 423, 426, 430, 440].includes(
            parseInt(chk_type.key)
          )
        ) {
          return false
        }
        return true
      })
    },
    application_list: function () {
      console.log('Original application_obj:', this.application_obj)

      const lists = [...this.application_obj]
      lists.map(list => {
        if (list?.application_type == 21000) {
          // itemsからデータを取得する関数
          const getItemValue = key => {
            if (!list.items) return null
            const item = list.items.find(item => item.application_key === key)
            return item ? item.application_value : null
          }

          // name_1, name_2, name_3の処理
          const name1 =
            list.name_1_new ||
            list.name_1 ||
            getItemValue('mfj_club_data@name_1') ||
            ''
          const name2 =
            list.name_2 || getItemValue('mfj_club_data@name_2') || ''
          const name3 =
            list.name_3 || getItemValue('mfj_club_data@name_3') || ''

          // yomi_1, yomi_2, yomi_3の処理
          const yomi1 =
            list.yomi_1 || getItemValue('mfj_club_data@yomi_1') || ''
          const yomi2 =
            list.yomi_2 || getItemValue('mfj_club_data@yomi_2') || ''
          const yomi3 =
            list.yomi_3 || getItemValue('mfj_club_data@yomi_3') || ''

          // 各ラベルの設定
          list.name_label = name1
          list.d_name_label = name2 + name3
          list.yomi_label = yomi1
          list.d_yomi_label = yomi2 + yomi3
          list.application_date =
            list.application_date || list.application_date_label_YmdHi

          // その他の必要なフィールドも同様に処理
          list.login_id =
            list.login_id || getItemValue('mfj_club_data@login_id')
          list.postal_cd =
            list.postal_cd || getItemValue('mfj_club_profile@postal_cd')
          list.address_1 =
            list.address_1 || getItemValue('mfj_club_profile@address_1')
          list.address_2 =
            list.address_2 || getItemValue('mfj_club_profile@address_2')
          list.tel_1 = list.tel_1 || getItemValue('mfj_club_profile@tel_1')
          list.mail_1 = list.mail_1 || getItemValue('mfj_club_profile@mail_1')
          list.club_no = ''
        } else {
          const name1 = list?.club_data?.name_1 ? list?.club_data?.name_1 : ''
          const name2 = list?.club_data?.name_2 ? list?.club_data?.name_2 : ''
          const name3 = list?.club_data?.name_3 ? list?.club_data?.name_3 : ''
          list.name_label = name1
          list.d_name_label = name2 + name3
          list.club_no = list?.club_data?.club_no
            ? list?.club_data?.club_no
            : ''
        }

        return list
      })

      return lists
    },
    application_check_type_display: function () {
      return [
        { key: '100', label: '未完了' },
        { key: '200', label: '保留' },
        { key: '500', label: '完了' },
        { key: '600', label: '完了' },
        { key: '900', label: '取消' }
      ]
    },
    getDisplayStatus: function () {
      const statusMap = this.statusMap
      return function (status) {
        return statusMap[status] || status
      }
    },
    get_page_num_list() {
      return [
        { key: 10, label: '10件' },
        { key: 20, label: '20件' },
        { key: 50, label: '50件' },
        { key: 100, label: '100件' }
      ]
    }
  },

  async created() {
    await this.loadConfigObj('application_check_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_type_group')
    await this.loadSearchParam()
    await this.initialLoad()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '申請データ一覧です。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.application_obj.find(app => {
          return app.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', {
            data: data,
            target: 'member_application'
          })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadCateList()
          })
      }
    },
    async loadSearchParam() {
      const params = {
        ...this.$store.getters.getSearchParam('club_application_list')
      }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },
    async search_club_no() {
      console.log('club_no', this.sprm.club_no, typeof this.sprm.club_no)
      if (this.sprm.club_no.length == 6) {
        await this.loadClubList(this.sprm.club_no)
      }
    },
    async loadClubList(club_no) {
      const params = {}
      params['stat'] = [1]
      params['club_no'] = club_no
      params['pagegroup'] = 'mfj_club_data.id'

      await this.basicPosts_S(config.BASE_API_URL + '/club/lists', params)
        .then(async response => {
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          let name_label = ''
          if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
          // if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
          // if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
          tmp_obj.name_label = name_label
          this.search_club_obj = tmp_obj
        })
        .catch(async err => {
          console.log(err)
          this.search_club_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },

    async initialLoad() {
      this.page = 0
      const params = {
        ...this.sprm,
        p: this.page,
        pagelimit: parseInt(this.page_limit)
      }
      await this.loadApplicationList(params)
    },

    async search_application() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        // this.page = 0
        const params = {
          ...this.sprm,
          p: this.page,
          pagelimit: parseInt(this.page_limit)
        }
        await this.loadApplicationList(params)
      } finally {
        this.isLoading = false
      }
    },
    async loadApplicationList(params) {
      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/club_application/lists',
          params
        )
        console.log('response', response)

        if (response.data && response.data.body) {
          this.application_obj = response.data.body
          this.alertMessage = '検索が完了しました'
          this.alertClass = 'alert-success'

          // ページャー情報の更新
          const setPageData = {
            data: response.data.pager || {},
            target: 'club_application_list'
          }
          this.$store.dispatch('setPager', setPageData)

          // 検索条件を保存
          this.$store.dispatch('setSearchParam', {
            data: params.sprm,
            target: 'club_application_list'
          })
        } else {
          this.application_obj = []
          this.alertMessage = 'データが見つかりませんでした'
          this.alertClass = 'alert-warning'
        }
      } catch (error) {
        console.error('Error in search_application:', error)
        this.application_obj = []
        this.alertMessage = 'エラーが発生しました'
        this.alertClass = 'alert-danger'
      }
    },
    clear() {
      // 検索条件をクリア
      Object.keys(this.sprm).forEach(key => {
        this.sprm[key] = ''
      })
      this.page = 0
      this.search_club_obj = {}
      this.search_application() // パラメータなしで呼び出し
    },
    handleClick(target) {
      this.$router.push({
        path: `/club_application/${target}`
      })
    },
    async pageAction(page) {
      this.page = parseInt(page)
      await this.search_application()
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseTypeList response', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/application_type',
        params
      )
        .then(async response => {
          console.log('loadApplicationTypeList response', response)
          this.application_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationCheckTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/application_check_type',
        params
      )
        .then(async response => {
          console.log('loadAffiliationTypeList response', response)
          this.application_check_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_check_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    prepareSearchParams() {
      const params = { stat: [1] }

      // 検索条件をパラメータに追加
      Object.keys(this.sprm).forEach(key => {
        if (this.sprm[key] !== '' && this.sprm[key] !== null) {
          params[key] = this.sprm[key]
        }
      })

      // ページネーション情報を追加
      params.pagelimit = this.page_limit
      params.p = this.page

      return params
    },
    async handlePageLimitChange() {
      try {
        this.page = 0
        const params = {
          sprm: {
            ...this.sprm,
            stat: [1],
            limit: parseInt(this.page_limit),
            page: this.page
          }
        }

        console.log('Sending params:', params)
        await this.search_application(params)
      } catch (error) {
        console.error('Error:', error)
      }
    },
    getItemValue(list, key) {
      if (!list.items) return null
      const item = list.items.find(item => item.application_key === key)
      return item ? item.application_value : null
    }
  },
  watch: {
    page_limit: {
      handler: 'handlePageLimitChange',
      immediate: false
    }
  }
}
</script>
